export default __webpack_public_path__ + "static/media/men.1af7e035.webp";